import { usePageProps } from "common/hooks/data/usePageProps"
import type { AppProps } from "common/lib/getAppServerSideProps"

export const useRegionConfig = () => {
  const { regionConfig } = usePageProps<AppProps>()

  return regionConfig
}
